/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";
// react-router-dom components
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
import { UserAPI } from "api/UserAPI";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import CircularProgress from "@mui/material/CircularProgress";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";

function Cover() {

  const formSchema = yup.object().shape({
    name: yup.string().required('El campo es requerido').max(30, 'El nombre no debe tener más de 30 caracteres'),
    email: yup.string().email('El email ingresado es incorrecto').required('El campo es requerido'),
    password: yup.string().required('El campo es requerido').min(8, 'La contraseña debe tener al menos 8 caracteres'),
    terms: yup.bool().oneOf([true], 'Debes aceptar los Términos y Condiciones'),
  })

  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const { handleSubmit, register, formState: { errors, isSubmitting }, } = useForm({ resolver: yupResolver(formSchema), });

  const alertComponent = (
    <MDAlert color={alertColor}>
      <MDTypography variant="body2" color="white">
        {alertContent}
      </MDTypography>
    </MDAlert>
  );


  const onSubmit = (data) => {
    return UserAPI.create(data)
      .then(response => {
        setAlertContent(response.message);
        setAlertColor('success');
        setAlert(true)

      }).catch(error => {
        setAlertContent(error.response.data.message);
        setAlertColor('error');
        setAlert(true)
      });

  }

  return (
    <CoverLayout >
      <MDBox mb={4} px={2}>
        {alert ? alertComponent : <></>}
      </MDBox>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Únete hoy
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Ingresa los siguientes datos para registrarte
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput type="text" label="Nombre" name="name" variant="standard" {...register("name")} fullWidth />
              {errors.name && <MDTypography variant="button" color="error">{errors.name?.message}</MDTypography>}

            </MDBox>
            <MDBox mb={2}>
              <MDInput type="email" label="Email" name="email" variant="standard" {...register("email")} fullWidth />
              {errors.email && <MDTypography variant="button" color="error">{errors.email?.message}</MDTypography>}

            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Contraseña" name="password" variant="standard" {...register("password")} fullWidth />
              {errors.password && <MDTypography variant="button" color="error">{errors.password?.message}</MDTypography>}
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox name="terms"  {...register('terms')} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Acepto los&nbsp;
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="button"
                fontWeight="bold"
                color="info"
                textGradient
              >
                Términos y Condiciones.
              </MDTypography>
            </MDBox>
            {errors.terms && <MDTypography variant="button" color="error">{errors.terms?.message}</MDTypography>}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Registrar'}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                ¿Ya tienes una cuenta?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Inicia Sesión
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
